<div class="bg-[#101011db] rounded-3xl w-fit">
    <div class="grounded-radiants">
        <ng-content></ng-content>
    </div>
</div>